module.exports = __webpack_public_path__ + "static/20240917_Announcement_HSE_Finance_Sarl_Mgmt-740d35480afbd552fdaba91a2a86051d.pdf";